<template>
    <div>
        <rkm-modal
            ref="RkmModal"
            title="Prescrição Interna"
            extraLarge
        >
            <List
                v-if="layout === 'list'"
                :data="data"
                @edit="handleEdit"
            />

            <Form
                v-else
                :data="data"
                :model="model"
                :open-modal-medicamento-on-load="openModalMedicamentoOnLoad"
                @saved="saved"
                ref="Form"
            />

            <template v-slot:footer="{ cancel }">
                <template v-if="layout === 'list'">
                    <rkm-button @click="cancel">
                        Fechar
                    </rkm-button>

                    <rkm-button
                        :disabled="data.model.prescricoesInternas.length === 0"
                        @click="replicarParaReceitaMedica"
                    >
                        Receitar medicação
                    </rkm-button>

                    <rkm-button
                        @click="handleCreate"
                        color="primary"
                    >
                        Nova prescrição interna
                    </rkm-button>
                </template>

                <template v-else>
                    <rkm-button @click="layout = 'list'">
                        Voltar
                    </rkm-button>

                    <rkm-button
                        @click="handleSave"
                        color="primary"
                    >
                        Salvar
                    </rkm-button>
                </template>
            </template>

            <modal-receita-medica ref="ModalReceitaMedica" :data="data" />
        </rkm-modal>
    </div>
</template>

<script>
// Components.
import Form from './Form'
import List from './List'

// Enums.
import medidaTempo from '@/enums/cadastro/medidaTempo'
import tipoAplicacao from '@/enums/pronto-atendimento/receita/tipoAplicacao'
import tipoPosologia from '@/enums/pronto-atendimento/receita/tipoPosologia'

export default {
    components: {
        Form,
        List,
        ModalReceitaMedica: () => import('@/components/pronto-atendimento/atendimento-medico/components/receita-medica/Modal'),
    },
    data: () => ({
        enums: {
            medidaTempo,
            tipoAplicacao,
            tipoPosologia,
        },
        layout: null,
        model: null,
        openModalMedicamentoOnLoad: false,
    }),
    methods: {
        open() {
            this.layout = 'list'
            this.$refs.RkmModal.show()
        },
        openCreateForm() {
            this.openModalMedicamentoOnLoad = true
            this.handleCreate()
            this.$refs.RkmModal.show()
        },
        handleCreate() {
            this.model = Object.assign({}, {
                lotacao: {
                    ocupacao: {
                        codigo: this.data.form.lotacao.ocupacao.codigo,
                    },
                    profissional: {
                        nome: this.data.form.lotacao.profissional.nome,
                    },
                },
                id: null,
                frequenciaQuantidadeVezes: null,
                frequenciaTempo: null,
                frequenciaMedidaTempoId: this.enums.medidaTempo.MINUTOS,
                observacoes: null,
                medicamentos: [],
                doseUnica: false,
            })

            this.$nextTick().then(() => this.layout = 'form')
        },
        handleEdit(item) {
            this.model = Object.assign({}, {
                lotacao: {
                    ocupacao: {
                        codigo: item.lotacao.ocupacao.codigo,
                    },
                    profissional: {
                        nome: item.lotacao.profissional.nome,
                    },
                },
                id: item.id,
                frequenciaQuantidadeVezes: item.frequenciaQuantidadeVezes,
                frequenciaTempo: item.frequenciaTempo,
                frequenciaMedidaTempoId: item.frequenciaMedidaTempoId,
                observacoes: item.observacoes,
                medicamentos: item.medicamentos,
                doseUnica: item.doseUnica,
            })

            this.layout = 'form'
        },
        handleSave() {
            this.$refs.Form.save()
        },
        saved() {
            this.layout = 'list'
        },
        replicarParaReceitaMedica() {
            this.data.model.prescricoesInternas.forEach(prescricaoInterna => {
                let tipoAplicacao = {
                    id: null,
                    nome: null,
                }

                const intervaloMedidaTempo = this.data.form.unidadesMedidaTempo.find(unidadeMedidaTempo => unidadeMedidaTempo.id === prescricaoInterna.frequenciaMedidaTempoId)

                if (prescricaoInterna.doseUnica) {
                    tipoAplicacao.id = this.enums.tipoAplicacao.DOSE_UNICA
                    tipoAplicacao.nome = 'Dose única'
                }

                prescricaoInterna.medicamentos.forEach((medicamento, i) => {
                    const HasMedicamentoReceitaMedica = this.data.model.receitaMedica.medicamentos.some(m => m.medicamento.id === medicamento.medicamento.id)

                    if (!HasMedicamentoReceitaMedica) {
                        const unidadeMedida = this.data.form.unidadesMedida.find(unidadeMedida => unidadeMedida.id === medicamento.unidadeMedidaId)

                        const item = {
                            isManual: false,
                            descricao: null,
                            duranteMedidaTempo: {
                                id: null,
                                nome: null,
                            },
                            duranteQuantidade: null,
                            id: this.uniqueId(`${i}-pronto-atendimento-atendimento-medico-receita-medica-medicamento-replicado`),
                            intervaloMedidaTempo: {
                                id: null,
                                nome: null,
                            },
                            intervaloTempo: prescricaoInterna.frequenciaTempo,
                            medicamento: {
                                exibirPrescricaoInterna: medicamento.medicamento.exibirPrescricaoInterna,
                                exibirReceita: medicamento.medicamento.exibirReceita,
                                formaFarmaceutica: medicamento.medicamento.formaFarmaceutica,
                                formaFarmaceuticaId: medicamento.medicamento.formaFarmaceuticaId,
                                id: medicamento.medicamento.id,
                                nome: medicamento.medicamento.nome,
                                receitaTipoId: medicamento.medicamento.receitaTipoId,
                                unidadeMedida: medicamento.medicamento.unidadeMedida,
                                unidadeMedidaId: medicamento.medicamento.unidadeMedidaId,
                                viaAdministracao: medicamento.medicamento.viaAdministracao,
                                viaAdministracaoId: medicamento.medicamento.viaAdministracaoId,
                            },
                            medicamentoCadastrado: 1,
                            quantidade: medicamento.quantidade,
                            recomendacoes: prescricaoInterna.observacoes,
                            tipoAplicacao: tipoAplicacao,
                            tipoPosologia: this.enums.tipoPosologia.FREQUENCIA,
                            turno: {
                                id: null,
                                nome: null,
                            },
                            unidadeMedida: {
                                id: unidadeMedida.id,
                                nome: unidadeMedida.nome,
                                sigla: unidadeMedida.sigla,
                            },
                            viaAdministracao: {
                                id: medicamento.medicamento.viaAdministracaoId,
                                nome: medicamento.medicamento.viaAdministracao,
                            },
                            viaAdministracaoOutras: null,
                        }

                        if (!prescricaoInterna.doseUnica) {
                            item.intervaloMedidaTempo = {
                                id: intervaloMedidaTempo.id,
                                nome: intervaloMedidaTempo.nome,
                            }
                        }

                        this.data.model.receitaMedica.medicamentos.push(item)
                    }
                })
            })

            this.$refs.RkmModal.hide()

            this.$emit('open-modal-receita-medica', null)

            this.showSaveNotification('Os medicamentos compatíveis com a receita médica foram replicados com sucesso, no entanto, é necessário acessar a receita médica para completar os dados.')
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>